<template>
    <div class="section" id="section-actualites">
        <div class="section-content">
            <div v-if="!loaded" class="container_preload">
                <div class="roulette"></div>
            </div>
            <div v-else-if="loaded">
                <div class="section-content-banner">
                    <div>ACTUALIT&Eacute;S</div>
                    <!-- <div v-if="actualites.last_modified" id="actu-last-modified">Dernière mise à jour le {{ actualites.last_modified }}</div> -->
                    <div class="closer fermer" @click="closeFooter()">╳</div>
                </div>
                <div class="section-content-loaded">
                    <div>
                        <ul class="actualites-wrapper" v-if="actualites.items.length > 0">
                            <li v-for="item in actualites.items" class="actu-item">
                                <div class="actu-type">{{ item.type }}</div>
                                <div class="actu-date-place">
                                    <div class="actu-date">{{ item.date }}</div>
                                    <div class="actu-place">{{ item.lieu }}</div>
                                </div>
                                <div class="actu-title">{{ item.titre }}</div>
                                <div class="actu-description">{{ item.description }}</div>
                                <div class="actu-person-wrapper">
                                    <ul>
                                        <li v-for="person in item.persons" class="actu-person">{{ person }}</li>
                                    </ul>
                                </div>
                                <div class="actu-link-wrapper">
                                    <ul>
                                        <li v-for="link in item.links" class="actu-link"><a :href="link.url" target="_blank">{{ link.text }}</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { url_annexes } from '../../variables.js';
import { url_actualites } from '../../variables.js';

export default {
    data() {
        return {
            loaded:false,
            contenu:"",
            actualites : []
        }
    },

    mounted: function() {
        this.axios.get(url_actualites).then((response) => {
            this.actualites = response.data;
            this.loaded = true;
        });
    },
    methods : {
        closeFooter(){
            //console.log(this);
            document.body.setAttribute("data-footer",false);
            document.getElementById("banner-title").parentElement.setAttribute("data-state","close");
            document.body.setAttribute("data-mode","");
        }
    }
};
</script>
<style>
    #actu-last-modified{
        display: block!important;
        margin-top: 9px;
    }
    .actualites-wrapper{
        display: block;
        margin-top: calc(var(--interlignage-courant));
    }
    .actu-item{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        padding-top: 5px;
        margin-bottom: calc(var(--interlignage-courant)*2);
        border-top: 2px dotted black;
    }
    .actu-item > div{
        padding-right: var(--lrm);
    }
    .actu-link-wrapper{
        padding-right: 0!important;
    }
    .actu-item ul, .actu-item li{
        list-style: none;
    }
    .actu-type{
        text-transform: uppercase;
    }
    .actu-title{
        font-style: italic;
    }
    .actu-item > div{
        width: 100%;
    }
    .actu-link:before{
        content: "→ ";
    }
    /*sizes*/
    @media screen and (min-width:751px){
        .actu-description{
            min-width: 460px;
        }
        .actu-type{
            min-width: 120px;
            max-width: 180px;
        }
        .actu-person-wrapper{
            max-width: 180px;
        }
        .actu-link-wrapper{
            min-width: 180px;
            max-width: 220px;
        }
    }
    @media screen and (max-width:750px){
        .actu-item{
            padding-top: calc(var(--interlignage-courant)*1);
        }
    }

    #section-actualites .section-content-loaded > div:empty:before{
        content: "Aucune actualité à afficher";
        color: red;
        margin-top: calc(39px / 3);
        display: table;
    }

</style>